import React from "react";
import type { ICellRendererParams } from "ag-grid-community";
import {
  TextButton,
  BadgeWrapper,
  IconButton,
  IconDelete,
} from "@cdkglobal/radial";

import {
  JsonSchemaItemProperty,
  RenderInputTypeParams,
} from "../../../../../types";

export const FormCellRenderer = (
  props: ICellRendererParams & {
    propertySubKey: string;
    item: JsonSchemaItemProperty;
    renderInputType: (params: RenderInputTypeParams) => JSX.Element;
  },
): React.ReactElement | null => {
  const rowIndex = props.data?.rowIndex;

  if (rowIndex === undefined) {
    return null;
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
      }}
    >
      {props.renderInputType({
        rowIndex,
        propertySubKey: props.propertySubKey,
        itemProperty: props.item,
        isInline: true,
      })}
    </div>
  );
};

export const RowActionsRenderer = (
  props: ICellRendererParams & {
    isReadOnly: boolean;
    isDeleteButtonDisabled: boolean;
    deleteRow: (rowIndex: number) => void;
    openSideSheet: (rowIndex: number) => void;
  },
): React.ReactElement | null => {
  const rowIndex = props.data?.rowIndex;
  const errorCount = props.data?.errorCount ?? 0;

  if (rowIndex === undefined) {
    return null;
  }

  const viewMoreButton = (
    <TextButton
      text="View"
      dataTestId={`view-row-${rowIndex}-button`}
      onClick={() => props.openSideSheet(rowIndex)}
    />
  );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
        height: "100%",
      }}
    >
      {errorCount > 0 ? (
        <BadgeWrapper
          badgeContent={String(errorCount)}
          badgeId={`row-${rowIndex}-error-badge`}
        >
          {viewMoreButton}
        </BadgeWrapper>
      ) : (
        viewMoreButton
      )}

      {!props.isReadOnly && (
        <IconButton
          icon={<IconDelete />}
          text="Delete"
          dataTestId={`delete-row-${rowIndex}-button`}
          isDisabled={props.isDeleteButtonDisabled}
          onClick={() => props.deleteRow(rowIndex)}
          style={{ cursor: "pointer" }}
        />
      )}
    </div>
  );
};
